import React, { useState, useEffect, Fragment } from "react";
import localization from "assets/localization/localization";
import Layout from 'components/sales/layout/layout';
import DivLayout from "../../../components/sales/divLayout/divLayout";

const ClientBusiness = ({ match, getClientBusinessDetails, clientBusiness }) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getClientBusinessDetails(match.params.comm_id)
            setIsLoading(false)
        })()
    }, [])

    return (
        <Layout
            title={localization.contractListing}
            isGoback
            isLoading={isLoading}
        >
            <div className="panel-card card-details" width="100%">
                <div className="panel-heading">Client Detail</div>
                <div className="panel-body">
                    <div className="details-listing detail_alignment">
                        <DivLayout heading={"Client Name"} data={clientBusiness?.data?.client_name} />
                        <DivLayout heading={"Registered Name"} data={clientBusiness?.data?.client_address?.registered_name} />
                        <DivLayout heading={"Locality"} data={clientBusiness?.data?.client_address?.locality} />
                        <DivLayout heading={"City"} data={clientBusiness?.data?.client_address?.city} />
                        <DivLayout heading={"State"} data={clientBusiness?.data?.client_address?.state} />
                        <DivLayout heading={"Pincode"} data={clientBusiness?.data?.client_address?.pincode} />
                        <DivLayout heading={"GST Number"} data={clientBusiness?.data?.client_address?.gst_number} />
                    </div>
                </div>
            </div>
            <div className="panel-card card-details" width="100%">
                <div className="panel-heading">Business Detail</div>
                <div className="panel-body">
                    <div className="details-listing detail_alignment">
                        <DivLayout heading={"Business Name"} data={clientBusiness?.data?.business_name} />
                        <DivLayout heading={"Registered Name"} data={clientBusiness?.data?.business_address?.registered_name} />
                        <DivLayout heading={"Address"} data={clientBusiness?.data?.business_address?.locality} />
                        <DivLayout heading={"City"} data={clientBusiness?.data?.business_address?.city} />
                        <DivLayout heading={"State"} data={clientBusiness?.data?.business_address?.state} />
                        <DivLayout heading={"Pincode"} data={clientBusiness?.data?.business_address?.pincode} />
                        <DivLayout heading={"GST Number"} data={clientBusiness?.data?.business_address?.gst_number} />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ClientBusiness